
import zappier from '../../assets/integraions/zappier.svg';
import QuickBooksOnline from '../../assets/integraions/quickbooks-online.svg';
import Salesforce from '../../assets/integraions/salesforce.svg';
import Dataverse from '../../assets/integraions/Dataverse.svg';
import Jobber from '../../assets/integraions/Jobber.svg';
import QuickbooksTime from '../../assets/integraions/QuickbooksTime.svg';
import Buildertrend from '../../assets/integraions/Buildertrend.svg';
import paycom from '../../assets/integraions/paycom.svg';
import ClockShark from '../../assets/integraions/ClockShark.svg';

export const connectors = [
    // {
    //   icon: QuickBooksOnline,
    //   title: 'Quickbooks Online',
    //   description: 'Easily Manage and Sync Your Data with Quickbooks Integration. Free Up Valuable Time for Your Business, Not Bookkeeping.',
    //   connected: false,
    //   connector: ''
    // },
    // {
    //   icon: zappier,
    //   title: 'Zappier',
    //   description: 'Streamline processes with custom workflows, advanced automation – no coding expertise necessary.',
    //   connected: true,
    //      connector: ''
    //     },
    // {
    //   icon: Salesforce,
    //   title: 'Salesforce',
    //   description: 'Securely connect data, systems, and AI models, automating tasks across diverse environments.',
    //   connected: false,
    //   connector: ''
    // },
    // {
    //     icon: Jobber,
    //     title: 'Jobber',
    //     description: 'Streamline appointments with online booking, and Jobber schedules jobs to your preferences.',
    //     connected: false,
    //     connector: ''
    // },
    // {
    //     icon: QuickbooksTime,
    //     title: 'Quickbooks Time',
    //     description: 'Streamline your financial tasks effortlessly by incorporating precise time tracking into your payroll and invoicing process.',
    //     connected: false,
    //     connector: ''
    // },
    // {
    //     icon: Dataverse,
    //     title: 'Dataverse',
    //     description: 'Seamlessly integrate data between finance, operations, Dataverse, and Dynamics 365 Sales for streamlined functionality.',
    //     connected: false,
    //     connector: ''
    // },
    {
        connector: 'buildertrend',
        is_active: false,
    },
    {
        connector: 'paycom',
        is_active: false,
    },
    {
        connector: 'clockshark',
        is_active: false,
    }
  ];
  export const connectorIcons = {
    buildertrend:Buildertrend,
    paycom:paycom,
    clockshark:ClockShark
  }

  export const connectorContent = {
    buildertrend:{
        icon: Buildertrend,
        title: 'Buildertrend',
        inputLableOne:'Username',
        payloadKeyOne:'username',
        payloadKeyTwo:'password',
        inputLabelTwo:'Password',
        description: 'Easily Manage and Sync Your Data with Buildertrend Integration. Free Up Valuable Time for Your Business, Not Bookkeeping.',
    },
    paycom:{
        icon: paycom,
        inputLableOne:'Sid',
        inputLabelTwo:'Token',
        payloadKeyOne:'sid',
        payloadKeyTwo:'token',
        title: 'Paycom',
        description: 'Easily Manage and Sync Your Data with Paycom Integration. Free Up Valuable Time for Your Business, Not Bookkeeping.',
    },
    clockshark:{
        icon: ClockShark,
        title: 'ClockShark',
        inputLableOne:'Email',
        payloadKeyOne:'username',
        payloadKeyTwo:'password',
        inputLabelTwo:'Password',
        description: 'Easily Manage and Sync Your Data with ClockShark Integration. Free Up Valuable Time for Your Business, Not Bookkeeping.',
    }
  }

export const getEnvironment = (origin) => {
    if (origin === 'http://localhost:3000') {
        return 'dev';
    } else if (origin === 'https://test.app.protiv.com') {
        return 'dev';
    } else if (origin === 'https://testkiwi.app.protiv.com') {
        return 'qa';
    } else if (origin === 'https://app.protiv.com') {
        return 'prod';
    } else {
        return 'qa';
    }
  };

  export const ERROR_MESSAGES = {
    ALREADY_RUNNING: 'Data synchronization is currently underway. Please wait until the current synchronization process completes before initiating a new one.',
    CONNECTOR_CONNECTION_NOT_FOUND: 'Connection lost with this connector',
    CLOCKSHARK_INVALID_EMAIL: 'Please enter a valid email.'
  }
  